
import * as THREE from 'three';
import { CreatePointData} from '../index';
import * as marietta from '../../..';
import { mm2D, pix2D, Unit } from '../../graphicLibs/util/unit';
import { PointInfo, WallType, WallToFitting, FittingType } from '../../WalltoFittingInfo';
import { Point } from '../../graphicLibs/math/Point';
import { BUILDING_TYPE_HOUSE, BUILDING_TYPE_MANSION } from '../../../webcad/Constants';


export class AddFitting2D {

    constructor(private buildingType: number, private wallToFittingInfo: WallType[]) {
        ;
    }

    /**
     * 建具2D表示
     * */
    public execute(pointList: PointInfo[], floor: number): void {
                
        /** 建具データの作成 **/
        const itemCollections = [];
        this.wallToFittingInfo.forEach((wallType: WallType) => {
            if (wallType.floor != floor) return;

            wallType.info.forEach((info: WallToFitting) => {
                const index = info.wallIndex * 2;
                /** 窓 **/
                if (info.windowIndex.length != 0) {
                    const itemInfo = this.positionCalculation('window', floor, info, pointList, info.windowIndex);
                    if (itemInfo.length > 0) itemCollections.push(...itemInfo);
                }

                /** ドア **/
                if (info.doorIndex.length != 0) {
                    const itemInfo = this.positionCalculation('door', floor, info, pointList, info.doorIndex);
                    if (itemInfo.length > 0) itemCollections.push(...itemInfo);
                }
                
                /** 開口 **/
                if (info.openingIndex.length != 0) {
                    const itemInfo = this.positionCalculation('opening', floor, info, pointList, info.openingIndex);
                    if (itemInfo.length > 0) itemCollections.push(...itemInfo);
                }
            });

        });

        marietta.webcad.util.WebcadJSONParser.reproduceCommonItem(itemCollections, 'fitting');
        
    }

    /** 内部か外部建具か判定 **/
    private isOuter = (pointList: PointInfo[], pointIndex: number): boolean => {
        const pointData = new CreatePointData(pointList);
        pointData.execute();
        const outerWallList = pointData.outerWallList;

        /** 外周判定 **/
        const next = Point.nextPoint(pointIndex);

        return (outerWallList.includes(pointIndex) || outerWallList.includes(next));
    }
    
    /** 
     * 建具位置・角度・大きさ 算出 
     * */
    private positionCalculation = (name: string, floor: number, info: WallToFitting, pointList: PointInfo[], fittingInfo: FittingType[]): marietta.webcad.collection.ItemInfoCollection[] => {

        /** 建具位置の算出用 **/
        const index = info.wallIndex * 2;
        const start = pointList[index].point;
        const end = pointList[Point.nextPoint(index)].point;
        const dir = end.clone().sub(start);
        const beforeWidth = info.wallWidth; // 補正前の壁幅
        const afterWidth = dir.clone().length(); // 補正後の壁幅
        const rateFittingWidth = Math.round(afterWidth / beforeWidth * 10) / 10;  // 建具幅を決めるため、割合を求める

        const getId = (width: number): string => {
            const modulePitch = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
            // if (name == 'window' && modulePitch <= width) return this.isOuter(pointList, index) == true ? 'fit07_07' : 'fit07_06'; // 引違２枚（金建て）: 引違２枚（木建て）
            // if (name == 'window' && width < modulePitch) return 'fit15_09'; // FIX
            // if (name == 'door') return this.isOuter(pointList, index) == true ? 'fit03_09' : 'fit03_08'; // 片開（金建て）: 片開（木建て）
            if (name == 'window' || name == 'door') return 'fit15_09'; // FIX
            if (name == 'opening') return 'fit02_01';
        }

        const createItemInfo = (id: string, pos: THREE.Vector2, width: number, height: number, mountingHeight: number, rotation: number): marietta.webcad.collection.ItemInfoCollection => {
            const center2D = new THREE.Vector2(marietta.webcad.WebCADGlobal.LAYER_SIZE_W/2, marietta.webcad.WebCADGlobal.LAYER_SIZE_H/2);
            const info: any = {};
            info.f = floor;
            const pix = <pix2D>new THREE.Vector2(center2D.x, center2D.y);
            if (this.buildingType == BUILDING_TYPE_MANSION) {
                /** マンション **/
                const posMMData = <mm2D>new THREE.Vector2(pos.x * 1000, pos.y * 1000);
                info.x = Unit.convertPixtoMm(pix).x + posMMData.x;
                info.y = Unit.convertPixtoMm(pix).y - posMMData.y;
            } else {
                /** 戸建て **/
                const beforeSnapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit;
                /** 中心座標が1/4グリッドに吸着するようにする **/
                const x =  marietta.webcad.util.WebCADUtil.convertMMToPix(pos.x * 1000);
                const y = marietta.webcad.util.WebCADUtil.convertMMToPix(pos.y * 1000);
                marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit = 0.25;
                const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
                const _x = Math.round(x / snapUnit) * snapUnit;
                const _y = Math.round(y / snapUnit) * snapUnit;
                info.x = pix.x + _x;
                info.y = pix.y - _y;
                /** 元の吸着単位をセット **/
                marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit = beforeSnapUnit;
            }
            info.id = id;
            info.guid = marietta.webcad.WebCADGlobal.getGuid();
            info.width = width;
            info.rotation = rotation;
            // if ((name == 'window' || name == 'door') && this.isOuter(pointList, index) == true) info.idthreed = `${id}_${height}_sash`;
            // if ((name == 'window' || name == 'door') && this.isOuter(pointList, index) == false) info.idthreed = `${id}_${height}_door`;
            info.auto_height = false;
            info.height = height;
            info.z = mountingHeight;
    
            return info;
        }

        const fittings: marietta.webcad.collection.ItemInfoCollection[] = [];
        fittingInfo.forEach((fit: FittingType) => {

            /** 建具位置の算出 **/
            const pos = dir.clone().multiplyScalar(fit.ratioFromStart).clone().add(start);                
            const vec2 = new THREE.Vector2(pos.x, pos.z);

            /** 角度 算出 **/
            const normalize = new THREE.Vector2(dir.x, dir.z).normalize();
            const rad = normalize.clone().angle();
            const rotation = Math.round(THREE.MathUtils.radToDeg(rad) * 1000) / 1000; // 小数第３位まで出力

            /** 幅 算出 **/
            let  width = fit.width * 1000 * rateFittingWidth;
            const id = getId(width);
            if (this.buildingType == BUILDING_TYPE_HOUSE) {
                // if (name == 'door') width = this.DoorWidth(width);
                // if (name == 'window' && (id == 'fit07_06' || id == 'fit07_07')) width = this.WindowWidth(width);
                // if (name == 'window' && id == 'fit15_09') width = this.FIXWidth(width);
                if (name == 'door' || name == 'window') width = this.FIXWidth(width);
                if (name == 'opening') width = this.OpeningWidth(width);
                width = marietta.webcad.util.WebCADUtil.convertMMToPix(width);
            }

            /** 高さ 算出 **/
            let height = fit.height * 1000;
            // if (name == 'door') height = this.DoorHeight(height);
            // if (name == 'window' && (id == 'fit07_06' || id == 'fit07_07')) height = this.WindowHeight(height);
            // if (name == 'window' && id == 'fit15_09') height = this.FIXHeight(height);
            if (name == 'door' || name == 'window') this.FIXHeight(height);
            if (name == 'opening') height = this.OpeningHeight(height);

            /** 取付高さ 算出 **/
            let mountingHeight = (fit.mountingHeight * 1000 < 2400) ? fit.mountingHeight * 1000 : 2400;
            if (mountingHeight < height) mountingHeight = height;
        
            fittings.push(createItemInfo(id, vec2, width, height, mountingHeight, rotation));
        });

        return fittings;
    }
                        
    /** 
     * ドア幅の調整（戸建て）
     * */
    private DoorWidth(width: number): number {
        if (width < 800) return 800;
        if (width > 1000) return 1000;
        return width;
    }
            
    /** 
     * ドア高さの調整
     * */
    private DoorHeight(height: number): number {
        if (height < 1800) return 1800;
        if (2400 <= height) return 2400;
        if (1800 <= height && height < 1900) return 1800;
        if (1900 <= height && height < 2150) return 2000;
        if (2150 <= height && height < 2350) return 2300;
        if (2350 <= height && height < 2400) return 2400;
        return height;
    }

    /** 
     * 窓幅の調整（戸建て）
     * */
    private WindowWidth(width: number): number {
        const modulePitch = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
        if (modulePitch <= width) return modulePitch * 2;
        if (width < modulePitch) {
            if (width <= (modulePitch / 4 + modulePitch / 8)) return modulePitch / 4; 
            if ((modulePitch / 4 + modulePitch / 8) < width && width <= (modulePitch / 2 + modulePitch / 8)) return modulePitch / 2; 
            if ((modulePitch / 2 + modulePitch / 8) < width && width <= (3 * modulePitch / 4 + modulePitch / 8)) return 3 * modulePitch / 4; 
            if ((3 * modulePitch / 4 + modulePitch / 8) < width && width <= (modulePitch + modulePitch / 8)) return modulePitch; 
            if ((modulePitch + modulePitch / 8) < width && width <= (5 * modulePitch / 4 + modulePitch / 8)) return 5 * modulePitch / 4; 
            if ((5 * modulePitch / 4 + modulePitch / 8) < width && width <= (3 * modulePitch / 2 + modulePitch / 8)) return 3 * modulePitch / 2; 
            if ((3 * modulePitch / 2 + modulePitch / 8) < width && width <= (7 * modulePitch / 4 + modulePitch / 8)) return 7 * modulePitch / 4; 
            if ((7 * modulePitch / 4 + modulePitch / 8) < width && width <= (2 * modulePitch + modulePitch / 8)) return 2 * modulePitch; 
        }

        return width;
    }
            
            
    /** 
     * 窓高さの調整
     * */
    private WindowHeight(height: number): number {
        if (height < 500) return 300;
        if (500 <= height && height < 750) return 700;
        if (750 <= height && height < 850) return 800;
        if (850 <= height && height < 950) return 900;
        if (950 <= height && height < 1050) return 1000;
        if (1050 <= height && height < 1150) return 1100;
        if (1150 <= height && height < 1250) return 1200;
        if (1250 <= height && height < 1400) return 1300;
        if (1400 <= height) return 1500;

        return height;
    }
            
    /** 
     * 開口幅の調整（戸建て）
     * */
    private OpeningWidth(width: number): number {
        const modulePitch = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
        const modulePitchDivide8 = modulePitch / 8;
        const quotient = width / modulePitch;
        if (width < modulePitch * quotient - modulePitchDivide8) return modulePitch - modulePitch / 4;
        if (modulePitch * quotient - modulePitchDivide8 <= width && width <= modulePitch * quotient + modulePitchDivide8) return modulePitch;
        if (modulePitch * quotient + modulePitchDivide8 < width) return modulePitch + modulePitch / 4;

        return width;
    }
            
    /** 
     * 開口高さの調整
     * */
    private OpeningHeight(height: number): number {
        if (height < 2100) return 2000; 
        if (2100 <= height && height < 2250) return 2200;
        if (2250 <= height) return 2300;

        return height;
    }

    /** 
     * FIX幅の調整
     * */
    private FIXWidth(width: number): number {
        const modulePitch = marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch;
        const modulePitchDivide2 = modulePitch / 2;
        const modulePitchDivide4 = modulePitch / 4;
        const modulePitchDivide8 = modulePitch / 8;
        if (width < modulePitchDivide4 + modulePitchDivide8) return modulePitchDivide4;
        if (modulePitchDivide4 + modulePitchDivide8 <= width && width < modulePitchDivide2 + modulePitchDivide8) return modulePitchDivide2;
        if (modulePitchDivide2 + modulePitchDivide8 <= width) return modulePitch;
    }

    /** 
     * FIX高さの調整
     * */
    private FIXHeight(height: number): number {
        if (2350 <= height) return 2400;
        if (2250 <= height && height < 2350) return 2300;
        if (2100 <= height && height < 2250) return 2200;
        if (1900 <= height && height < 2100) return 2000;
        if (1650 <= height && height < 1900) return 1800;
        if (1400 <= height && height < 1650) return 1500;
        if (1200 <= height && height < 1400) return 1300;
        if (1050 <= height && height < 1200) return 1100;
        if (950 <= height && height < 1050) return 1000;
        if (800 <= height && height < 950) return 900;
        if (650 <= height && height < 800) return 700;
        if (550 <= height && height < 650) return 600;
        if (425 <= height && height < 550) return 500;
        if (325 <= height && height < 425) return 350;
        if (275 <= height && height < 325) return 300;
        if (225 <= height && height < 275) return 250;
        if (175 <= height && height < 225) return 200;
        if (height < 175) return 150;
    }

}